import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Motion";

const PILLARS = [
  {
    n: "01",
    title: "Guided Breathwork",
    desc: "Soft, grounding breath sequences to settle the nervous system and open the morning.",
    img: "https://images.unsplash.com/photo-1643682661119-28da0685be2c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHx3b21lbiUyMG1lZGl0YXRpb24lMjBicmVhdGh3b3JrJTIwY2lyY2xlJTIwd2FybSUyMHRvbmVzfGVufDB8fHx8MTc5MTgxNjQ5NHww&ixlib=rb-4.1.0&q=85",
    tint: "bg-[#D6E0D8]",
  },
  {
    n: "02",
    title: "Gentle Somatic Movement",
    desc: "Slow, intuitive movement to release what the body has been quietly holding.",
    img: "https://images.unsplash.com/photo-1625865020971-581242d0ead6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHx3b21lbiUyMGJyZWF0aHdvcmslMjBjaXJjbGUlMjB3ZWxsbmVzcyUyMG1vdmVtZW50JTIwam91cm5hbGluZyUyMGFydHxlbnwwfHx8d2hpdGV8MTc5MTgxNjQ4Nnww&ixlib=rb-4.1.0&q=85",
    tint: "bg-[#E8E3F0]",
  },
  {
    n: "03",
    title: "Expressive Art",
    desc: "Colour, texture and play — art as feeling, not as skill. Everything you make is enough.",
    img: "https://images.unsplash.com/photo-1669016950126-3f11b53e2b0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxleHByZXNzaXZlJTIwcGFpbnRpbmclMjBhcnRpc3QlMjBjYW52YXMlMjBoYW5kcyUyMHdhdGVyY29sb3IlMjB3YXJtfGVufDB8fHx8MTc5MTgxNjQ5NHww&ixlib=rb-4.1.0&q=85",
    tint: "bg-[#F4E3E0]",
  },
  {
    n: "04",
    title: "Reflective Journaling",
    desc: "Guided prompts to listen inward, name what is true, and close the circle with intention.",
    img: "https://images.unsplash.com/photo-1562878274-ad7a29ea8cdd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHx3b21hbiUyMGpvdXJuYWxpbmclMjBub3RlYm9vayUyMGNvZmZlZSUyMHN1bmxpZ2h0JTIwd2FybXxlbnwwfHx8fDE3OTE4MTY0OTR8MA&ixlib=rb-4.1.0&q=85",
    tint: "bg-[#F0EDF7]",
  },
];

export const Activities = () => (
  <section id="activities" className="bg-[#F5F0E8] py-20 lg:py-32" data-testid="activities-section">
    <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
      <Reveal className="max-w-2xl">
        <Eyebrow>What we will do together</Eyebrow>
        <h2 className="mt-5 font-serif text-3xl font-light tracking-tight text-[#262320] sm:text-4xl lg:text-5xl">
          Four gentle pillars of the morning
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {PILLARS.map((p, i) => (
          <Reveal key={p.n} delay={i * 0.1}>
            <motion.div
              whileHover={{ y: -8 }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              className="group h-full rounded-[26px] border border-[#D9C3A3]/50 bg-white/80 p-5 shadow-sm"
              data-testid={`activity-card-${i}`}
            >
              <div className={`relative overflow-hidden rounded-[20px] ${p.tint}`}>
                <img
                  src={p.img}
                  alt={p.title}
                  className="aspect-[4/5] w-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-white/85 px-3 py-1 font-mono text-xs text-[#5E7D6A] backdrop-blur">
                  {p.n}
                </span>
              </div>
              <h3 className="mt-6 font-serif text-xl font-medium text-[#262320] sm:text-2xl">{p.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#6E6862]">{p.desc}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
